import { gql } from "lib/apolloClient";
import { classPlannerFragment } from "./ClassPlannersFragments";

export const getWeeklyPlannerTemplateByCourseQuery = gql`
  query getWeeklyPlannerTemplateByCourse(
    $id: ID!
    $exceptionalCollaboratorFilters: ExceptionalCollaboratorUserFilter!
  ) {
    node(id: $id, type: COURSE) {
      id
      ... on Course {
        id
        title
        weeklyPlannerTemplates {
          ...classPlannerItem
        }
      }
    }
  }
  ${classPlannerFragment.classPlannerItemFragment}
`;

export const getWeeklyPlannerTemplateSectionsQuery = gql`
  query getWeeklyPlannerTemplateSections(
    $id: ID!
    $filters: WeeklyPlannerSectionFilters
    $collaboratorFilters: CollaboratorFilters!
  ) {
    node(id: $id, type: WEEKLY_PLANNER_TEMPLATE) {
      id
      ... on WeeklyPlannerTemplate {
        id
        title
        startDate
        endDate
        enabledSections {
          sections
        }
        defaultAccessState
        courses {
          id
          title
          primaryGrade {
            id
          }
          __typename
        }
        sections(filters: $filters) {
          ...weeklyPlannerSectionItem
        }
        __typename
      }
      __typename
    }
  }
  ${classPlannerFragment.weeklyPlannerSectionFragment}
`;

export const getCalendarEventsQuery = gql`
  query getCalendarEvents(
    $rangeBeginStartDate: String!
    $rangeEndStartDate: String!
  ) {
    school {
      calendarEvents(
        rangeBeginStartDate: $rangeBeginStartDate
        rangeEndStartDate: $rangeEndStartDate
      ) {
        ...calendarEvent
      }
    }
  }
  ${classPlannerFragment.calendarEvent}
`;

export const getPlatformCalendarEventItemsQuery = gql`
  query getPlatformCalendarEventItems(
    $rangeBeginStartDate: String!
    $rangeEndStartDate: String!
    $filters: CalendarEventFilter
  ) {
    platform {
      calendarEventItems(
        rangeBeginStartDate: $rangeBeginStartDate
        rangeEndStartDate: $rangeEndStartDate
        filters: $filters
      ) {
        id
        start: startDateTime
        end: endDateTime
        title: label
        tag: eventTag {
          id
          colorCode
        }
        associatedEntities {
          ... on Grade {
            id
          }
        }
      }
    }
  }
`;

export const getOrganizationTemplatesWithTypeQuery = gql`
  query getOrganizationTemplatesWithType(
    $id: ID!
    $filters: OrganizationTemplateFilter
  ) {
    node(id: $id, type: ORGANIZATION) {
      ... on Organization {
        id
        templates(filters: $filters) {
          id
          body
          type
          assessmentType
        }
      }
    }
  }
`;

export const getCourseAcademicYearsQuery = gql`
  query getCourseAcademicYears($id: ID!) {
    node(id: $id, type: COURSE) {
      ... on Course {
        id
        academicYears {
          id
          startDate
          endDate
        }
      }
    }
  }
`;
